export default "__VITE_ASSET__CeMbxeGK__"